import React from "react";
import { useNavigate } from "react-router-dom";
import { useT } from "../../i18n";

const BackButton = () => {
    const navigate = useNavigate();
    const { t } = useT();

    const handleBackClick = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <div className="header">
           <button type="button" className="back-link" onClick={handleBackClick}>&#8592; {t('Back')}</button>
        </div>
    );
};

export default BackButton;
